import * as React from "react";
import { SVGProps } from "react";

const Banano = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 300 300"
    {...props}
  >
    <defs>
      <radialGradient
        id="a"
        cx="15.884%"
        cy="10.899%"
        r="97.159%"
        fx="15.884%"
        fy="10.899%"
      >
        <stop offset="0%" stopColor="#FFF" stopOpacity={0.15} />
        <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
      </radialGradient>
      <path
        id="b"
        d="M127.312 92.314c-55.777 7.022-81.46-42.086-76.905-46.877 3.008-3.163 7.685-3.353 11.738-3.462 18.649-.505 45.045 21.268 50.399 21.16 10.368-.211 25.967-16.69 36.188-30.274 4.278-5.683 31.003-14.245 28.04.684-9.61 48.419-42.353 57.874-49.46 58.77ZM49.688.686c55.777-7.022 81.46 42.086 76.903 46.877-3.008 3.163-7.683 3.353-11.736 3.462-18.649.505-45.045-21.27-50.399-21.16-10.368.211-25.967 16.69-36.19 30.274-4.276 5.683-31 14.245-28.037-.682C9.838 11.036 42.58 1.58 49.689.686Z"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <rect width={300} height={300} fill="#FBDD11" rx={150} />
      <path
        fill="#E8C900"
        d="M300 150c0 82.843-67.157 150-150 150S0 232.843 0 150c0-.5.002-1 .007-1.5C.812 230.652 67.657 297 150 297c82.342 0 149.188-66.348 149.993-148.5.005.5.007 1 .007 1.5Z"
      />
      <path
        fill="#FFEF7F"
        d="M299.993 151.5C299.188 69.348 232.343 3 150 3 67.658 3 .812 69.348.007 151.5.002 151 0 150.5 0 150 0 67.157 67.157 0 150 0s150 67.157 150 150c0 .5-.002 1-.007 1.5Z"
      />
      <rect width={270} height={270} x={15} y={15} fill="#2A2A2E" rx={135} />
      <rect width={300} height={300} fill="url(#a)" rx={150} />
      <g transform="translate(61.8 103.8)">
        <use xlinkHref="#b" fill="#000" />
        <use xlinkHref="#b" fill="#FBDD11" />
      </g>
      <path
        fill="#FFEF7F"
        d="M188.783 150.618c-1.977-11.96-27.777-49.966-77.295-43.732-7.107.895-39.85 10.35-49.46 58.77-.06.31-.11.61-.146.9-.142-.943-.104-2.037.147-3.3 9.609-48.42 42.352-57.875 49.46-58.77 53.628-6.751 79.436 38.386 77.294 46.132Zm-76.968 1.763c-.25-1.511-.12-2.607.392-3.144 3.008-3.163 7.685-3.353 11.738-3.462 18.649-.505 45.045 21.268 50.399 21.16 10.368-.211 25.967-16.69 36.188-30.274 4.19-5.565 29.904-13.891 28.186-.214-1.542-10.204-24.27-2.588-28.186 2.614-10.221 13.584-25.82 30.063-36.188 30.275-5.354.107-31.75-21.666-50.4-21.161-4.052.109-8.73.299-11.737 3.462-.176.184-.306.434-.392.744Z"
      />
      <path
        fill="#E8C900"
        d="M188.783 148.218c.25 1.512.12 2.607-.392 3.145-3.008 3.163-7.683 3.353-11.736 3.462-18.649.505-45.045-21.27-50.399-21.16-10.368.211-25.967 16.69-36.19 30.274-4.187 5.565-29.902 13.891-28.184.216 1.542 10.202 24.27 2.586 28.184-2.616 10.223-13.584 25.822-30.063 36.19-30.275 5.354-.109 31.75 21.666 50.4 21.161 4.052-.109 8.727-.299 11.735-3.462.176-.184.306-.435.392-.745Zm-76.968 1.763c1.978 11.96 27.778 49.967 77.297 43.733 7.107-.895 39.85-10.35 49.46-58.769.06-.31.11-.609.146-.898.142.942.104 2.036-.147 3.298-9.609 48.419-42.352 57.874-49.46 58.77-53.63 6.75-79.438-38.39-77.296-46.134Z"
      />
    </g>
  </svg>
);

export default Banano;
